<template>
  <div class="common-box">
    <el-form
      inline
      ref="form"
      class="search-form common-box-search-form"
      label-position="right"
      :model="form"
      label-width="70px"
    >
      <search-form @search="handleSearch" @refresh="handleRefresh">
        <div slot="content">
          <el-form-item label="使用单位：">
            <el-select
              size="mini"
              v-model="form.propertyUnitId"
              filterable
              placeholder="请选择所属单位"
              clearable
              reserve-keyword
              :remote="true"
              @change="handleSearchListData"
              :remote-method="searchUnitList"
              @visible-change="searchUnitList('')"
            >
              <el-option
                v-for="item in unitList"
                :key="item.id"
                :label="item.unitName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属项目：">
            <el-select
              size="mini"
              v-model="form.projectId"
              filterable
              placeholder="请选择所属项目"
              clearable
              reserve-keyword
              :remote="true"
              @change="handleSearchListData"
              :remote-method="searchProjectList"
              @visible-change="searchProjectList('')"
            >
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="item.projectName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="使用编号：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.useCertificateNumber"
              placeholder="请输入使用编号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="省市区：" class="input-with-col2">
            <AddreassSelect
              :isSearch="true"
              :warning="addressWarn"
              :showDetailAddress="showDetailAddress"
              :addressName="addressName"
              class="input-with-col2"
              @change="setPojectAddress"
            ></AddreassSelect>
          </el-form-item>

          <el-form-item label="电梯位置：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.liftLocation"
              placeholder="请输入电梯位置"
              clearable
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="所属部门：">
            <el-cascader
              placeholder="请选择所属部门"
              :options="departmentTree"
              :props="propsTree"
              filterable
              @change="handleDepartment"
              ref="cascader"
              collapse-tags
              v-model="departmentIdList"
            ></el-cascader>
          </el-form-item> -->
          <el-form-item label="工单编号：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.orderNo"
              placeholder="请输入工单编号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="添加时间：">
            <el-date-picker
              v-model="form.createTimeBetween"
              size="mini"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              unlink-panels
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="所属部门：">
            <el-cascader
              placeholder="请选择所属部门"
              :options="departmentTree"
              :props="propsTree"
              filterable
              size="mini"
              @change="handleDepartment"
              ref="cascader"
              collapse-tags
              v-model="departmentIdList"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="用户：">
            <el-select
              size="mini"
              v-model="form.maintainPersonIdList"
              filterable
              placeholder="请选择用户"
              clearable
              reserve-keyword
              :remote="true"
              collapse-tags
              multiple
              @change="handleSearchListData"
              :remote-method="searchUserList"
              @visible-change="searchUserList('')"
            >
              <el-option
                v-for="item in userList"
                :key="item.userId"
                :label="item.nickname"
                :value="item.userId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="完成状态：">
            <el-select
              size="mini"
              v-model="form.planOrderStatus"
              placeholder="请选择"
              clearable
              @change="handleSearchListData"
            >
              <el-option
                v-for="item in planOrderStatusList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="超期：">
            <el-select
              size="mini"
              v-model="form.overdueStatus"
              placeholder="请选择"
              clearable
              @change="handleSearchListData"
            >
              <el-option
                v-for="item in overdueStatusList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="是否签字：">
            <el-select
              size="mini"
              v-model="form.signatureStatus"
              placeholder="请选择"
              clearable
              @change="handleSearchListData"
            >
              <el-option
                v-for="item in isSignList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="超期：">
            <el-select
              size="mini"
              v-model="form.overdueStatus"
              placeholder="请选择"
              clearable
              @change="handleSearchListData"
            >
              <el-option
                v-for="item in isSignList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="位置异常：">
            <el-select
              size="mini"
              v-model="form.locationStatus"
              placeholder="请选择"
              clearable
              @change="handleSearchListData"
            >
              <el-option
                v-for="item in isSignList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item> -->
        </div>
      </search-form>
    </el-form>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button
          size="mini"
          type="primary"
          class="plr28"
          @click="addPlan"
          v-if="hasRole['WBJHTJ']"
          >添加</el-button
        >
        <el-button
          size="mini"
          type="primary"
          class="plr28"
          plain
          @click="handleDelete"
          v-if="hasRole['WBJHSC']"
          >删除</el-button
        >
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="list"
          height="100%"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="orderNo"
            label="工单编号"
            width="160"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="projectName"
            label="项目名称"
            width="160"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="liftLocation"
            label="电梯位置"
            width="200"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="maintainTypeName"
            label="维保类型"
            width="150"
          ></el-table-column>
          <!-- <el-table-column show-overflow-tooltip prop="operatorUserName" label="维保员" width="150"></el-table-column> -->
          <!-- <el-table-column show-overflow-tooltip prop="startTime" label="开始时间" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="endTime" label="结束时间" width="200"></el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            prop="planTime"
            label="计划时间"
            width="200"
          ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="templateName"
              label="模板名称"
              width="200"
            >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="status"
            label="完成状态"
            width="200"
          >
            <template slot-scope="scope">
              {{ scope.row.status | filterS }}
            </template>
          </el-table-column>

          <!-- <el-table-column show-overflow-tooltip prop="elapsedTime" label="耗时" width="90"></el-table-column> -->
          <!-- <el-table-column show-overflow-tooltip prop="locationStatusName" label="位置异常" width="100">
          </el-table-column> -->
          <!-- <el-table-column show-overflow-tooltip prop="signatureStatusName" label="签字" width="90"></el-table-column>
      		<el-table-column show-overflow-tooltip prop="contactsPhone" label="图片数量" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="overdueStatusName" label="超期" width="90"></el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            prop="propertyUnitName"
            label="使用单位"
            width="250"
          ></el-table-column>
          <!-- <el-table-column show-overflow-tooltip prop="electronicWorkOrderStatusName" label="电子工单" width="100"></el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            prop="contactsPhone"
            label="省市区"
            width="100"
          >
            <template slot-scope="scope"
              >{{ scope.row.provinceName ? scope.row.provinceName + "," : ""
              }}{{ scope.row.cityName ? scope.row.cityName + "," : ""
              }}{{ scope.row.districtName }}</template
            >
          </el-table-column>
          <el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="148px" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                v-if="hasRole['WBJHCK'] && scope.row.status === 3"
                @click="handleCheck(scope.row)"
                >查看</el-button
              >
              <div
                class="btn-divide"
                v-if="hasRole['WBJHBJ'] && scope.row.status === 3"
              ></div>
              <el-button
                size="mini"
                type="text"
                v-if="hasRole['WBJHBJ'] && scope.row.status === 1"
                @click="editPlan(scope.row)"
                >编辑</el-button
              >
              <div
                class="btn-divide"
                v-if="hasRole['WBJHBJ'] && scope.row.status === 1"
              ></div>
              <el-button
                size="mini"
                v-if="hasRole['WBJHSC'] && scope.row.status === 1"
                type="text"
                @click="handleDeleteUnit(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <check-order
      v-if="checkOrder"
      :editData="orderDetail"
      @cancel="checkOrder = false"
    ></check-order>
    <AddPlan
      v-if="showAddPlan"
      @cancel="showAddPlan = false"
      @confirm="handleConfirm"
    ></AddPlan>
    <EditPlan
      v-if="showEditPlan"
      :editData="orderDetail"
      @cancel="showEditPlan = false"
      @confirm="handleConfirmEdit"
    ></EditPlan>
  </div>
</template>

<script>
import { getDepartmentTree } from "@/api/ElevatorManagement";
import {
  getMaintainOrderPlanList,
  deleteOrderPlan,
  getProjectSimpleList,
  getPropertyUnitSimpleList,
  getUserSimpleList,
} from "@/api/MaintenancePlan";
import AddreassSelect from "@/components/AddreassSelect/AddreassSelect";
import CheckOrder from "../MaintenanceWorkOrder/components/CheckOrder";
import AddPlan from "./components/AddPlan";
import EditPlan from "./components/EditPlan";
export default {
  name: "MaintenancePlan",
  components: {
    CheckOrder,
    AddreassSelect,
    AddPlan,
    EditPlan,
  },
  data() {
    return {
      showAddPlan: false,
      showEditPlan: false,
      form: {
        // departmentIdList: [],
        propertyUnitId: "",
        projectId: "",
        useCertificateNumber: "",
        cityCode: "",
        districtCode: "",
        provinceCode: "",
        liftLocation: "",
        orderNo: "",
        startCreateTime: "",
        endCreateTime: "",
        createTimeBetween: null,
        signatureStatus: "",
        overdueStatus: "",
        locationStatus: "",
        planOrderStatus: "",
        maintainPersonIdList: null,
      },
      tableLoading: false,
      list: [],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      checkOrder: false,
      orderDetail: {},
      unitList: [],
      projectList: [],
      addressWarn: false,
      showDetailAddress: false,
      addressName: "省市区",
      isSignList: [
        {
          code: 1,
          name: "是",
        },
        {
          code: 2,
          name: "否",
        },
      ],
      overdueStatusList: [
        {
          code: 1,
          name: "正常",
        },
        {
          code: 2,
          name: "超期",
        },
        {
          code: 3,
          name: "提前",
        },
      ],
      planOrderStatusList: [
        {
          code: 1,
          name: "计划中",
        },
        {
          code: 2,
          name: "执行中",
        },
        {
          code: 3,
          name: "已完成",
        },
      ],
      departmentTree: [],
      propsTree: {
        multiple: true,
        value: "id",
        label: "departmentName",
        children: "childrenList",
        // checkStrictly: true
      },
      userList: [],
      departmentIdList: [],
    };
  },
  computed: {
    hasRole: function () {
      return this.$store.getters["common/promise/getRole"](this.$route.path);
    },
  },
  created() {
    this.getListData();
    // this.getDepartmentTree()
    this.getDepartmentTree();
  },
  methods: {
    async getDepartmentTree() {
      const res = await getDepartmentTree({ pageIndex: 1, pageSize: 1000 });
      if (res.code === 200) {
        this.departmentTree = res.data;
      }
    },
    async getListData() {
      this.tableLoading = true;
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      if (this.form.createTimeBetween) {
        delete params.createTimeBetween;
        params.endCreateTime = this.form.createTimeBetween[1];
        params.startCreateTime = this.form.createTimeBetween[0];
      }
      const res = await getMaintainOrderPlanList(params);
      if (res.code === 200) {
        this.total = res.data.total;
        this.list = res.data.list;
      }
      this.tableLoading = false;
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleRefresh() {
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.pageIndex = 1;
      this.getListData();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDeleteUnit(row) {
      const idList = [row.orderId];
      this.deleteOrderPlan(idList);
    },
    handleCheck(row) {
      this.orderDetail = row;
      this.checkOrder = true;
    },
    handleDelete() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的行");
        return;
      }
      const idList = this.multipleSelection.map((item) => item.orderId);
      this.deleteOrderPlan(idList);
    },
    deleteOrderPlan(idList) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteOrderPlan({ idList });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getListData();
    },
    async searchUnitList(keyword) {
      const res = await getPropertyUnitSimpleList({
        keyword: keyword,
        size: 1000,
      });
      if (res.code === 200) {
        this.unitList = res.data;
      }
    },
    async searchProjectList(keyword) {
      const res = await getProjectSimpleList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.projectList = res.data;
      }
    },
    async searchUserList(keyword) {
      const res = await getUserSimpleList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.userList = res.data;
      }
    },
    setPojectAddress(data) {
      this.form.address = data.addressData; // 项目地址 详细地址
      this.form.provinceCode = data.provinceCode; // 项目地址省级 code
      this.form.provinceName = data.provinceName; // 项目地址省级 name
      this.form.cityCode = data.cityCode; // 项目地址城市 code
      this.form.cityName = data.cityName; // 项目地址城市 name
      this.form.districtCode = data.townCode; // 项目地址区级 code
      this.form.districtName = data.townName; // 项目地址区级 name
    },
    handleDepartment(val) {
      this.form.departmentIdList = [];
      if (val && val.length) {
        const nodes = this.$refs.cascader.getCheckedNodes();
        nodes.forEach((item) => {
          this.form.departmentIdList.push(item.data.id);
        });
      }
      this.handleSearchListData();
    },
    handleConfirm() {
      this.showAddPlan = false;
      this.handleSearchListData();
    },
    addPlan() {
      this.showAddPlan = true;
    },
    editPlan(row) {
      this.orderDetail = row;
      this.showEditPlan = true;
    },
    handleConfirmEdit() {
      this.showEditPlan = false;
      this.getListData();
    },
  },
  filters: {
    filterS(val) {
      if (val == 1) {
        return "计划中";
      } else if (val == 2) {
        return "执行中";
      } else if (val == 3) {
        return "已完成";
      } else {
        return "";
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/MaintenancePlan/MaintenancePlan.vue